import { PostFnolAction, PostFnolActionTypes } from './post-fnol.actions';
import { PostFnolContext } from './post-fnol.models';

export const POSTFNOL_FEATURE_KEY = 'postFnol';

export interface PostFnolState {
  context: PostFnolContext;
  claimNumber: string;
  policyNumber: string;
  customerId: string;
  name: string;
  userId: string;
  exposureId: string;
  vin: string;
  emailAddress: string;
  garageZipcode: string;
}

export const initialState: PostFnolState = {
  context: null,
  claimNumber: null,
  policyNumber: null,
  customerId: null,
  name: null,
  userId: null,
  exposureId: null,
  vin: null,
  emailAddress: null,
  garageZipcode: null
};

export function postFnolReducer(
  state: PostFnolState = initialState,
  action: PostFnolAction
): PostFnolState {
  switch (action.type) {
    case PostFnolActionTypes.InitPostFnolFlow:
      return Object.assign({}, state, action.payload);

    case PostFnolActionTypes.ResetPostFnolFlow:
      return Object.assign({}, initialState);

    default:
      return state;
  }
}
